// === COMMON ===
export const COMMON_DEPARTMENTS = "/Common/departments";
export const COMMON_UTILITIES = '/Common/utilities';
export const COMMON_SYSTEMROLES = '/Common/systemroles';
export const COMMON_ROLES = "/Common/roles";
export const COMMON_SHIFTS = "/Common/shifts";

// === USER ===
export const USER_PROFILE_ENDPOINT = "/User/profile";
export const USER_MY_PROFILE_ENDPOINT = "/User/me";
export const USER_ENDPOINT = "/User";
export const USER_PROFILE_ID_ENDPOINT = (id: string) => `/User/profile/${id}`;
export const USER_ID_ENDPOINT = (id: string) => `/User/${id}`;
export const USER_ROLE_ID_ENDPOINT = (id: string) => `/User/role/${id}`;
export const USER_UNDER_MANAGER_ENDPOINT = () => `/User/undermanager`;
export const USER_PROFILE_CREATE_ENDPOINT = "/profile";
export const USER_REGISTRATION_ENDPOINT = "/User/registration";

// === ATTENDANCE ===
export const ATTENDANCE = "/Attendance";
export const ATTENDANCE_SCHEDULE = "/Attendance/schedule";
export const ATTENDANCE_SCHEDULE_CREATE = "/Attendance/schedule/create";
export const ATTENDANCE_SCHEDULE_CONFIGURATION = "/Attendance/schedule/configuration";
export const ATTENDANCE_DELETE_SCHEDULE_CONFIGURATION = (id: string) => `/Attendece/schedule/configuration${id}`;
export const ATTENDANCE_SUMMARY = (year: number, month: number) => `${ATTENDANCE}/summary/${year}/${month}`;
export const ATTENDANCE_VIEW_MYSELF_TEAM = (id: string, year: number, month: number) =>`/Attendance/overview/${id}/${year}/${month}`;
export const ATTENDANCE_APPROVE_INDIVIDUAL = (id: string, year: number, month: number) => `Attendance/approve/user/${id}/year/${year}/month/${month}`;
export const ATTENDANCE_APPROVE_MYTEAM  = (id: string, year: number, month: number) => `/Attendance/approve/myteam/${id}/year/${year}/month/${month}`;

// === USERSCHEDULE ===
export const USERSCHEDULE_GET_SCHEDULE_ATTENDANCE = (id: string, year: number, month: number) =>  `UserSchedule/attendance/${id}/year/${year}/month/${month}`;
export const USERSCHEDULE_CREATE_SCHEDULE = "/UserSchedule/create";
export const USERSCHEDULE_GET_SCHEDULE_CONFIGURATION = (id: string, year: number, month: number) => `/UserSchedule/configuration/${id}/year/${year}/month/${month}`;
export const USERSCHEDULE_DELETE_SCHEDULE_CONFIGURATION = (id: string) => `/UserSchedule/configuration${id}`;


// === ENTITY SCHEDULE ===
export const ENTITY_SCHEDULE_CREATE = "/EntitySchedule/create";
export const ENTITY_SCHEDULE_PRIMARY = "/EntitySchedule/User";
export const ENTITY_SCHEDULE_SECONDARY = "/EntitySchedule/Receiver";

// === PATIENT ===
export const PATIENT_PROFILE = "/Patient/profile";
export const PATIENT = "/Patient";
export const PATIENT_PROFILE_ID = (id: string) => `/Patient/profile/${id}`;
export const PATIENT_REGISTRATION = "/Patient/registration";
export const PATIENT_REGISTRATION_APPROVE = (id: string) => `/Patient/registration/approve/${id}`;
export const PATIENT_REGISTRATION_REVIEW = "/Patient/registration/review";




// === COMPENSATION ===
export const COMPENSATION_GETPDF_PAYSLIP = (id: string, year: number, month: number) => `/Compensation/${id}/payslip/${year}/${String(month).padStart(2, "0")}`; 
export const COMPENSATION_CALCULATE_CTC = "/Compensation/breakup";
export const COMPENSATION_GENERATE_PAYROLL = (year: number, month: number) => `/Compensation/pay/generate/${year}/${month}`;
export const COMPENSATION_CALCULATE_MONTHLY_PAYOUT = (year: number, month: number) => `/Compensation/pay/summary/${year}/${month}`; 


// === Student Registration ===
export const STUDENT_REGISTRATION = "/StudentRegistration/upsert"
export const STUDENT_GET_REGISTRATION = "/StudentRegistration"
export const STUDENT_CLASSES = "/Student/classes"
export const DOCUMENT_UPLOAD = "/documents/upload"
// /api/documents/upload

// /api/StudentRegistration/upsert


export const EMAIL_VERIFICATION = (email: string) => `/StudentRegistration/generate/otp?email=${encodeURIComponent(email)}`;


export const EMAIL_VERIFICATION_VERIFY = (email: string, otp: string) => `/StudentRegistration/verify/otp?email=${encodeURIComponent(email)}&otp=${encodeURIComponent(otp)}`;

export const STUDENT_GETREGISTRATION_EMAIL = (email: string) => `/StudentRegistration/${encodeURIComponent(email.trim())}`;


export const STUDENT_PROFILE_WITH_PARENTS = (studentId: string) =>
  `/StudentRegistration/${encodeURIComponent(studentId)}/profile/withparents`;


export const STUDENT_GETCOURSE = "/Student/courses"


export const STUDENT_UPLOAD_PROFILE_PICTURE = (studentId: string) =>
  `/Student/${studentId}/ProfilePicture`;

export const STUDENT_GETBUS_ROUTE = "/Student/bus/route"
